<div
  class="cascading-editable-inputs-container"
  [attr.id]="formlyAttributes?.id"
  [attr.name]="formlyAttributes?.name">
  <form *ngIf="form" [formGroup]="form">
    <ng-container *ngFor="let field of configs; let index = index">
      <div *ngIf="!field.parent || hasParentValue(field.parent)" class="mb-3">
        <div class="form-group">
          <label [for]="field.key" class="form-label tt_norms400">
            {{ field.label | translate }} <span *ngIf="field.required">*</span>
          </label>

          <div
            class="editable-input-container"
            [class.is-editing]="editingStates[field.key]">
            <div
              class="input-wrapper"
              [class.invalid]="
                form.get(field.key)?.invalid && form.get(field.key)?.touched
              ">
              <div class="input-section">
                <div
                  class="custom-dropdown-wrapper"
                  [class.editing-mode]="editingStates[field.key]">
                  <!-- Block interaction when not in editing mode -->
                  <div
                    *ngIf="!editingStates[field.key]"
                    class="interaction-blocker"></div>

                  <!-- The actual dropdown component -->
                  <irembogov-select
                    [loading]="loading[field.key]"
                    [formControlName]="field.key"
                    [items]="
                      items && items[field.key] ? items[field.key] : null
                    "
                    [bindLabel]="field.bindlabel"
                    [disabled]="!editingStates[field.key]"
                    [bindValue]="field.bindvalue"
                    [placeholder]="field.placeholder | translate"
                    [labelForId]="field.key"
                    [multiple]="field.multiple === true"
                    [virtualScroll]="true"
                    (itemSelected)="onSelectChange($event, field.key)"
                    (focus)="
                      formlyAttributes?.focus && formlyAttributes.focus()
                    "
                    (blur)="formlyAttributes?.blur && formlyAttributes.blur()">
                  </irembogov-select>
                </div>

                <!-- Inner action buttons -->
                <div class="inner-actions">
                  <!-- Cancel button when editing -->
                  <ng-container *ngIf="editingStates[field.key]">
                    <button
                      class="btn clear-btn"
                      (click)="cancelEdit(field.key)"
                      placement="top"
                      container="body"
                      ngbTooltip="{{ 'Discard changes' | translate }}">
                      <i class="fa fa-times"></i>
                    </button>
                  </ng-container>

                  <!-- Edited badge and reset button for topmost parent only -->
                  <ng-container
                    *ngIf="
                      !editingStates[field.key] &&
                      isEdited(field.key) &&
                      isTopmostParent(field)
                    ">
                    <span class="edited-badge">
                      {{ 'Edited' | translate }}
                    </span>
                    <button
                      class="btn reset-btn"
                      (click)="resetToInitial(field.key)"
                      placement="top"
                      container="body"
                      ngbTooltip="{{ 'Undo Changes' | translate }}"
                      style="z-index: 20">
                      <i class="fa fa-refresh"></i>
                    </button>
                  </ng-container>

                  <!-- Edited badge only for non-topmost parent fields -->
                  <ng-container
                    *ngIf="
                      !editingStates[field.key] &&
                      isEdited(field.key) &&
                      !isTopmostParent(field)
                    ">
                    <span class="edited-badge">
                      {{ 'Edited' | translate }}
                    </span>
                  </ng-container>
                </div>
              </div>

              <!-- Main action buttons -->
              <div class="actions">
                <!-- Save button when editing -->
                <ng-container *ngIf="editingStates[field.key]">
                  <button
                    class="action-btn save-btn"
                    (click)="saveEdit(field.key)"
                    [disabled]="form.get(field.key)?.invalid">
                    <i class="fa fa-check"></i>
                    {{ 'Save' | translate }}
                  </button>
                </ng-container>

                <!-- Edit button when not editing -->
                <ng-container *ngIf="!editingStates[field.key]">
                  <button
                    class="action-btn edit-btn"
                    (click)="startEdit(field.key)"
                    [disabled]="isAnyFieldEditing(field.key)">
                    <i class="fa fa-edit"></i>
                    {{ 'Edit' | translate }}
                  </button>
                </ng-container>
              </div>
            </div>

            <!-- Validation error message -->
            <div
              class="invalid-feedback"
              style="display: block"
              *ngIf="form.get(field.key)?.invalid">
              <ng-container *ngIf="form.get(field.key)?.errors">
                {{ 'This field is required' | translate }}
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
